import type { ApiResult } from "../../../../models/ApiResult";

/** Backend może zwrócić isError: false przy messageType warning/error i errorTable — nadal nieudany zapis ankiety. */
export const isSurveySaveFailure = (response: ApiResult | null | undefined): boolean => {
  if (!response) return true;
  if (response.isError) return true;
  const errs = response.errorTable?.filter((s) => typeof s === "string" && s.trim() !== "") ?? [];
  if (errs.length === 0) return false;
  return response.messageType !== "info";
};
